//
// Suggestions
// A view controller that is used by the AI Assist Widget to render the recommended suggestions
//

define(function(require) {
  var ViewController = require('web-agent-framework/ViewController');
  var SuggestionViewController = require('web-agent-viewControllers/SuggestionViewController');
  var SuggestionEmptyViewController = require('web-agent-viewControllers/SuggestionEmptyViewController');

  var SuggestionsViewController = ViewController.extend({
    ControllerName: 'SuggestionsViewController',

    LPViewMap: {
      suggestionsWrapper: '.lp_ai_assist_suggestions_wrapper'
    },

    LPClassesMap: {
      hidden: 'lp_ai_assist_hidden'
    },

    initialize: function(data) {
      // Set up references controllers
      this.suggestionsController = lpTag.WebAgent.suggestionsController;
      this.logicController = lpTag.WebAgent.logicController;

      // Setup context variables
      this.modelController = data.modelController;
      this.visitorId = data.visitorId;
      this.scrollToTop = data.scrollToTop;

      // Get useful parameters from the model
      this.chatId = this.logicController.getChatIdFromVisitorId(this.visitorId);
      this.visitorName = this.modelController.getModelParam(
        'chats.' + this.chatId + '.visitorInfo.visitorName'
      );
      this.agentId = this.modelController.getModelParam(
        'chats.' + this.chatId + '.agentInfo.agentId'
      );

      // Define a handleSuccess function for the suggestions
      var handleSuggestion = function(chat, suggestion) {
        // Scroll the parent container to the top
        this.scrollToTop();
        // Create suggestions using the suggestion with the highest score
        this.createSuggestion(chat, suggestion);
        // Hide empty messages view
        this.refreshEmptySuggestion();
      };

      // Initialise the suggestions controller
      this.suggestionsController.initialize({
        agentId: this.agentId,
        accountId: LE.loginInfo.accountId,
        handleSuggestion: handleSuggestion.bind(this)
      });

      // Listen for new chat lines and process each one
      this.modelController.bindModelParam(
        'chats.' + this.chatId + '.oldChatLine.lines',
        this.handleChatLines,
        this
      );
      this.modelController.bindModelParam(
        'chats.' + this.chatId + '.newChatLine.lines',
        this.handleChatLines,
        this
      );

      this.emptySuggestionViewController = this.addEmptySuggestion();
    },

    events: function() {},

    render: function() {}
  });

  SuggestionsViewController.prototype.getActiveSuggestions = function() {};

  SuggestionsViewController.prototype.addEmptySuggestion = function() {
    var emptySuggestionViewController = new SuggestionEmptyViewController({
      className: 'lp_ai_assist_suggestion_view_empty',
      templateFile: 'LP_ai_assist_widget_suggestion_empty.html',
      visitorName: this.visitorName
    });

    this.addViewController({
      viewController: emptySuggestionViewController,
      target: this.getFirstElement(this.LPViewMap.suggestionsWrapper)
    });

    return emptySuggestionViewController;
  };

  SuggestionsViewController.prototype.refreshEmptySuggestion = function() {
    // Get active suggestions
    var suggestions = this.suggestionsController.getActiveSuggestions(
      this.viewControllers
    );

    if (suggestions.length) {
      // Hide empty messages view
      this.addClass(
        this.emptySuggestionViewController.view,
        this.LPClassesMap.hidden
      );
    } else {
      // Show empty messages view
      this.removeClass(
        this.emptySuggestionViewController.view,
        this.LPClassesMap.hidden
      );
    }
  };

  SuggestionsViewController.prototype.handleChatLines = function(data) {
    this.suggestionsController
      .getVisitorChatsWithoutState(data, lpTag.AMSStatics.messageState.READ)
      .forEach(this.suggestionsController.fetchSuggestions.bind(this));
  };

  SuggestionsViewController.prototype.createSuggestion = function(
    chat,
    suggestion
  ) {
    // Create new suggestion controller
    var suggestionViewController = new SuggestionViewController({
      suggestion: suggestion,
      chat: chat,
      visitorId: this.visitorId,
      agentId: this.agentId,
      refreshEmptySuggestion: this.refreshEmptySuggestion.bind(this),
      className: 'lp_ai_assist_suggestion_view lp_ai_assist_visible',
      templateFile: 'LP_ai_assist_widget_suggestion.html'
    });

    this.addViewController({
      viewController: suggestionViewController,
      target: this.getFirstElement(this.LPViewMap.suggestionsWrapper)
    });
  };

  return SuggestionsViewController;
});
